import FacebookBlack from "../../../icons/social/FacebookBlack";
import FacebookGray from "../../../icons/social/FacebookGray";
import InstaBlack from "../../../icons/social/InstaBlack";
import InstaGray from "../../../icons/social/InstaGray";
import TwitterBlack from "../../../icons/social/TwitterBlack";
import TwitterGray from "../../../icons/social/TwitterGray";
import LinkedInBlack from "../../../icons/social/LinkedInBlack";
import LinkedInGray from "../../../icons/social/LinkedInGray";
import Blank from "../../../icons/social/Blank";
import NewTabA11y from "../../../global/a11y/NewTabA11y";

export default {
  functional: true,
  props: {
    link: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    hasCompleted: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  render(createElement, context) {
    const { type, link, hasCompleted } = context.props;
    let element = null;

    switch (type) {
      case 'instagram':
        element = link ? InstaBlack : InstaGray;
        break;
      case 'facebook':
        element = link ? FacebookBlack : FacebookGray;
        break;
      case 'twitter':
        element = link ? TwitterBlack : TwitterGray;
        break;
      case 'linkedin':
        element = link ? LinkedInBlack : LinkedInGray;
        break;
      default:
        element = Blank;
    }

    if (hasCompleted && !link) {
      return null;
    }

    return createElement(
      NewTabA11y,
      { props: { href: link } },
      [
        createElement(
          element,
          context.data,
          context.children
        )
      ]
    );
  }
}
